import type { FC } from 'react';

import BackButton from 'components/BackButton';
import { StepProps } from 'components/Stepper/types';
import * as Layout from 'layouts/StickyStepperLayout';

import { useSubmitBankTransferRequest } from '../../../../hooks/useSubmitBankTransferRequest';
import { useBankTransferRequestsNewState } from '../../../BankTransferRequestsNewProvider';
import TransferInformationForm from './components/TransferInformationForm';

const TransferInformation: FC<StepProps> = ({ goBack, goNext }) => {
  const [submitBankTransferRequest] = useSubmitBankTransferRequest();

  const { dispatch, recipientInformation, transferInformation } =
    useBankTransferRequestsNewState();

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={goBack} />
        </Layout.HeaderButtonsContainer>
        <TransferInformationForm
          defaultValues={transferInformation}
          onRecipientCardClick={goBack}
          onSubmit={async (data) => {
            try {
              if (
                !recipientInformation ||
                !recipientInformation.swiftBic ||
                !recipientInformation.name ||
                !recipientInformation.iban ||
                !recipientInformation.country
              ) {
                // It should never happen, but just in case
                goBack();
                return;
              }
              dispatch({
                payload: data,
                type: 'SUBMIT_TRANSFER_INFORMATION',
              });
              await submitBankTransferRequest({
                amount: data.amount,
                country: recipientInformation.country,
                iban: recipientInformation.iban,
                label: data.label,
                name: recipientInformation.name,
                supportingDocument: data.supportingDocument,
                swiftBic: recipientInformation.swiftBic,
              });
              goNext({
                key: 'transfer-success',
              });
            } catch (err) {
              // fail silently as we are handling errors with the hook and needed
              // for react hook form to correctly reset the `isSubmitting` state
            }
          }}
          recipientInformation={recipientInformation}
        />
      </Layout.Body>
    </Layout.Root>
  );
};

export default TransferInformation;
